import {Link} from 'react-router-dom';
import React from 'react';
import styled from 'styled-components';

import {HeadlineH1} from './text/Headlines';
import {RCol, Row} from './Grid';
import {TopBar, TopBarLeftCol} from './form/FormElements';
import EntityTable from './table/EntityTable';

const InvalidField = styled.div`
  color: ${props => props.theme.alternateColor};
`;

export const displayMeta = meta => {
  if (meta) {
    if (meta.validatedAtStr) {
      return <Link to={`/metadata/edit/${meta._id}`}>{meta.value}</Link>;
    } else {
      return (
        <Link to={`/metadata/edit/${meta._id}`}>
          <InvalidField>{meta.value !== '' ? meta.value : 'kein Wert'}</InvalidField>
        </Link>
      );
    }
  }
  return null;
};

export const mapLabel = metaType => {
  let label = '';
  switch (metaType) {
    case 'winType':
      label = 'Konstruktion';
      break;
    case 'winClass':
      label = 'Rahmenstärke';
      break;
    case 'variation':
      label = 'Typ';
      break;
    case 'uValueFrame':
      label = 'Ur';
      break;
    case 'windLoad':
      label = 'Windlast';
      break;
    case 'glassType':
      label = 'Glastyp';
      break;
    case 'uValueGlass':
      label = 'Ug';
      break;
    case 'placeholder':
      label = 'Platzhalter';
      break;
    case 'psiValue':
      label = 'Abst.h. psi';
      break;
    case 'drivingRain':
      label = 'Schlagregen';
      break;
    case 'rainRackProd':
      label = 'Regenschiene Hersteller';
      break;
    case 'rainRackType':
      label = 'Regenschiene';
      break;
    case 'sealProd':
      label = 'Dichtungshersteller';
      break;
    case 'wingSeal':
      label = 'Überschlagdichtung';
      break;
    case 'foldSeal':
      label = 'Falzdichtung';
      break;
    case 'coatingProd':
      label = 'Beschlaghersteller';
      break;
    case 'coatingType':
      label = 'Beschlagtyp';
      break;
    case 'profileDie':
      label = 'Profilwerkzeug';
      break;
    case 'airPermeable':
      label = 'Luftdurchlässigkeit';
      break;
    case 'operateForce':
      label = 'Bedienkräfte';
      break;
    case 'mechanicalStress':
      label = 'Mechanische Beanspruchung';
      break;
    case 'thermalInsulation':
      label = 'Uw';
      break;
    case 'soundInsulation':
      label = 'dB';
      break;
    default:
      label = '';
  }
  return label;
};
const _tableConfig = () => {
  return {
    maxRows: 20,
    cols: [
      {
        header: 'Typ',
        valueKey: 'label',
        width: '200px',
        method: label => label,
      },
      {
        header: 'Wert',
        valueKey: '*',
        width: '200px',
        method: displayMeta,
      },
    ],
  };
};
const MetaData = ({data}) => {
  let metas = [];
  if (data.allMetas && data.allMetas.length > 0) {
    metas = data.allMetas.map(meta => {
      return {_id: meta._id, label: mapLabel(meta.metaType), value: meta.value, validatedAtStr: meta.validatedAtStr};
    });
  }
  return (
    <div>
      <TopBar>
        <Row>
          <TopBarLeftCol size={0.3} style={{paddingLeft: 100}}>
            <HeadlineH1>Meta Daten</HeadlineH1>
          </TopBarLeftCol>
          <RCol size={0.7} />
        </Row>
      </TopBar>

      <EntityTable tableConfig={_tableConfig()} data={metas} msg={'Noch keine Einträge erstellt'} showFilter={true} />
    </div>
  );
};
export default MetaData;



// WEBPACK FOOTER //
// ./src/components/MetaDatas.js